import { BaseService, Service } from "/@/cool";
@Service("customerService")
class CustomerService extends BaseService {
	constructor() {
		super();

		let prefix = "";
		if (this.namespace) {
			prefix = this.namespace.replace(/\//g, ":") + ":";
		}

		this.permission["add"] = prefix + "add";
		this.permission["update"] = prefix + "update";
		this.permission["page"] = prefix + "page";
		this.permission["list"] = prefix + "list";
		this.permission["info"] = prefix + "info";
		this.permission["updateAddress"] = prefix + "updateAddress";
	}
	updateAddress(params: any) {
		return this.request({
			url: "/updateAddress",
			method: "POST",
			params
		});
	}
}
export default CustomerService;
